import type { MelodyDuration } from '@tunasong/schemas'
import type { EasyScoreDuration } from '../easy-score/duration.js'

/** Map a MelodyNote duration to a VexFlow StaveNote duration token. */
export const melodyDurationToVexFlow = (d: MelodyDuration): EasyScoreDuration => {
  const map: Record<MelodyDuration, EasyScoreDuration> = {
    '1n': 'w',
    '2n': 'h',
    '4n': 'q',
    '8n': '8',
    '16n': '16',
  }
  return map[d]
}
